import { sidebarPage } from '../utils/sidebarPageLayout.js';
import { logOut } from '../../src/auth.js';

export class SignOut {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <div class="fg-signout-card">
                <img src="/images/logo2.png" alt="FootballGirl" style="width: 80px; margin-bottom: 20px;">
                <h2>Sign Out</h2>
                <p>
                    Are you sure you want to sign out of your FootballGirl account?
                    You'll need to sign in again to access your personalized content and settings.
                </p>
                <div class="fg-signout-actions">
                    <button type="button" class="fg-btn fg-btn--primary" id="fg-signout-confirm">Yes, Sign Out</button>
                    <button type="button" class="fg-btn" id="fg-signout-cancel">Cancel</button>
                </div>
            </div>
        `;

        el.innerHTML = sidebarPage({ title: '', subtitle: '', main });

        el.querySelector('#fg-signout-confirm')?.addEventListener('click', () => {
            logOut().then(() => {
                // Sign-out successful.
                console.log('User signed out successfully');
                if (window.app?.handleNavigation) {
                    window.app.handleNavigation('home');
                }
            }).catch((error) => {
                console.error('Sign out error:', error);
                window.alert('Failed to sign out. See console for details.');
            });
        });

        el.querySelector('#fg-signout-cancel')?.addEventListener('click', () => {
            if (window.app?.handleNavigation) {
                window.app.handleNavigation('home');
            }
        });
    }
}
